import {ContactInterface} from "../interfaces/ContactInterface";

export const contactsCEO: ContactInterface[] = [
    {
        key: "Email", value: "nikita.pletnev@insightquestor.com", link: "mailto:nikita.pletnev@insightquestor.com", iconType: "email"
    },
    {
        key: "Phone(EU)", value: "+358 406 261070", link: "tel:+358406261070", iconType: "phone"
    },
    {
        key: "LinkedIn", value: "LinkedIn", link: "https://www.linkedin.com/in/nikita-pletnev-421b14178/", iconType: "linkedin"
    },
    {
        key: "Phone(UAE)", value: "+971 522 82 53 81", link: "tel:+971522825381", iconType: "phone"
    },
    {
        key: "Github", value: "Github", link: "https://github.com/NikitaPletnev", iconType: "github"
    },
    {
        key: "Telegram", value: "Telegram", link: "https://t.me/Nick_pletnev", iconType: "telegram"
    },
    {
        key: "Schedule Meeting", value: "Calendly", link: "https://calendly.com/nikita_pletnev/1-hour-meeting", iconType: "event"
    },
];

export const contactsCOO: ContactInterface[] = [
    {
        key: "LinkedIn", value: "LinkedIn", link: "https://www.linkedin.com/in/colin-reid-892262246/", iconType: "linkedin"
    },
];

export const contactsCTO: ContactInterface[] = [
    {
        key: "LinkedIn", value: "LinkedIn", link: "https://www.linkedin.com/in/sergeyevdmitry", iconType: "linkedin"
    },
];

export const contactsCFA: ContactInterface[] = [
    {
        key: "LinkedIn", value: "LinkedIn", link: "https://www.linkedin.com/in/jukka-hemmi-1aa28b165", iconType: "linkedin"
    },
];

